import { z } from "zod";

const SettingsSchema = z.object({
  days: z
    .string()
    .trim()
    .nonempty("Days are required")
    .regex(/^\d+$/, "Days must be a number.")
    .transform((val) => Number(val))
    .refine((val) => Number.isInteger(val) && val > 0, {
      message: "Days must be greater than 0.",
    })
    .refine((val) => val <= 365, {
      message: "Days cannot be more than 365.",
    }),
});

export default SettingsSchema;
